import { useRouteError, Link } from 'react-router';
import { RefreshCw, Home } from 'lucide-react';
import { Button } from '../ui/components';

const ErrorBoundary = () => {
  const error = useRouteError();
  
  console.error('Route Error:', error);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 480, width: '100%' }}>
        <div style={{ padding: 48, textAlign: 'center', border: '1px solid var(--ds-border-default)', borderRadius: 'var(--ds-border-radius-large)' }}>
          <h1 style={{ fontSize: '4rem', fontWeight: 800, color: 'var(--ds-text-primary)', marginBottom: 16 }}>
            Oops!
          </h1>
          
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--ds-text-primary)', marginBottom: 16 }}>
            Something went wrong
          </h2>
          
          <p style={{ fontSize: '1rem', color: 'var(--ds-text-secondary)', marginBottom: 32 }}>
            {error?.statusText || error?.message || 'An unexpected error occurred. Please try again.'}
          </p>

          {error?.status && (
            <p style={{ fontSize: '0.75rem', color: 'var(--ds-text-tertiary)', marginBottom: 24 }}>
              Error Code: {error.status}
            </p>
          )}

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <Button variant="secondary" onClick={() => window.location.reload()}>
              <RefreshCw size={16} style={{ marginRight: 8 }} />
              Try Again
            </Button>
            
            <Link to="/" style={{ textDecoration: 'none' }}>
              <Button variant="primary">
                <Home size={16} style={{ marginRight: 8 }} />
                Go Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
